import * as types from "store/login/loginTypes";

export const loginRequest = (payload) => ({
  type: types.POST_LOGIN_REQUESTED,
  payload: payload
});

export const adminLoginRequest = (payload) => ({
  type: types.POST_ADMIN_LOGIN_REQUESTED,
  payload: payload
});

export const updatePasswordRequest = (payload) => ({
  type: types.POST_UPDATE_PASSWORD_REQUESTED,
  payload: payload
});

export const closeResetPasswordModal = () => ({
  type: types.CLOSE_RESET_PASSWORD_MODAL,
});

export const isI2andQsToolUser = (payload) => ({
  type: types.IS_I2_AND_QS_TOOL_USER_REQUESTED,
  payload: payload
});

export const sendResetPasswordEmailRequest = (payload) => ({
  type: types.SEND_RESET_PASSWORD_EMAIL_REQUESTED,
  payload: payload
});

export const toggleI2andQsToolUserModal = (payload) => ({
  type: types.TOGGLE_I2_AND_QS_TOOL_USER_MODAL,
  payload: payload
});
